'use client';

import { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();

  const navLinks = {
    en: [
      { id: 'nav_home', label: 'Home', href: '/homepage' },
      { id: 'nav_about', label: 'About', href: '/about' },
      { id: 'nav_services', label: 'Services', href: '/services' },
      { id: 'nav_contact', label: 'Contact', href: '/contact' },
      { id: 'nav_calculator', label: 'Diagnostic', href: '/calculator' },
    ],
    es: [
      { id: 'nav_home', label: 'Inicio', href: '/homepage' },
      { id: 'nav_about', label: 'Nosotros', href: '/about' },
      { id: 'nav_services', label: 'Servicios', href: '/services' },
      { id: 'nav_contact', label: 'Contacto', href: '/contact' },
      { id: 'nav_calculator', label: 'Diagnóstico', href: '/calculator' },
    ],
  };

  const ctaText = {
    en: 'Book',
    es: 'Agendar',
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b hairline border-border">
      <div className="max-w-screen-xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link href="/homepage" className="text-xl font-bold tracking-tight text-foreground hover:text-primary transition-colors">
            GUZMAN RODRIGUEZ
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks[language].map((link) => (
              <Link
                key={link.id}
                href={link.href}
                className="text-sm font-medium text-foreground hover:text-primary transition-colors relative group"
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full" />
              </Link>
            ))}
          </nav>

          {/* Right Side Actions */}
          <div className="flex items-center gap-4">
            {/* Language Toggle */}
            <button
              onClick={toggleLanguage}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              aria-label="Toggle Language"
            >
              {language === 'en' ? 'ES' : 'EN'}
            </button>

            {/* CTA Button */}
            <Link
              href="/contact"
              className="hidden md:inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-primary-foreground bg-primary sharp hover:bg-primary/90 transition-all duration-300"
            >
              {ctaText[language]}
            </Link>

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden text-foreground"
              aria-label="Toggle Menu"
            >
              <Icon name={isMenuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={24} />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t hairline border-border pt-4">
            <div className="flex flex-col gap-4">
              {navLinks[language].map((link) => (
                <Link
                  key={link.id}
                  href={link.href}
                  className="text-sm font-medium text-foreground hover:text-primary transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                href="/contact"
                className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-primary-foreground bg-primary sharp hover:bg-primary/90 transition-all duration-300"
                onClick={() => setIsMenuOpen(false)}
              >
                {ctaText[language]}
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;